import React, { useState } from "react";

import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import {
  IdsExpandMore as ArrowDropDownIcon,
  IdsExpandLess as ArrowDropUpIcon,
} from "components/shared/svgIcons";
import { Menu, MenuItem } from "components/shared";

export type DesignActionType = "Published" | "Unpublished";

const useStyles = makeStyles(() => ({
  menu: {
    width: 136,
  },
}));

export const BulkAction: React.FC<{
  onAction: (action: DesignActionType) => void;
  disabled?: boolean;
}> = ({ onAction, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const classes = useStyles();

  return (
    <React.Fragment>
      <Button
        color="primary"
        variant="outlined"
        endIcon={
          <Box width={22} height={22} marginRight={-1.25}>
            {Boolean(anchorEl) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </Box>
        }
        size="small"
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          setAnchorEl(event.currentTarget)
        }
        disableElevation
        disabled={disabled}
        style={{ zIndex: 1 }}
      >
        Bulk action
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
        classes={{ paper: classes.menu }}
      >
        {(["Published", "Unpublished"] as DesignActionType[]).map(
          (action: DesignActionType, index: number) => (
            <MenuItem key={index} size="sm" onClick={() => onAction(action)}>
              {action === "Published" ? "Publish" : "Unpublish"}
            </MenuItem>
          )
        )}
      </Menu>
    </React.Fragment>
  );
};
